import { PlayerMetricHeuristic } from '../../jscaip/AI/PlayerMetricHeuristic';
import { Player } from '../../jscaip/Player';
import { PlayerNumberTable } from '../../jscaip/PlayerNumberTable';
export class DiaballikDistanceHeuristic extends PlayerMetricHeuristic {
    getMetrics(node, _config) {
        const state = node.gameState;
        // Inverse of ball distance, i.e., higher if the ball is closest to opponent line
        const ballsCloseness = new PlayerNumberTable();
        for (const coordAndContent of state.getCoordsAndContents()) {
            const piece = coordAndContent.content;
            if (piece.holdsBall) {
                if (piece.owner === Player.ZERO) {
                    ballsCloseness.set(Player.ZERO, [state.getHeight() - 1 - coordAndContent.coord.y]);
                }
                else {
                    ballsCloseness.set(Player.ONE, [coordAndContent.coord.y]);
                }
            }
        }
        return ballsCloseness;
    }
}
